const HashtagsDark = ({ color }: any) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.66699 8.25H18.3337" stroke="#141A4D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.66699 13.75H18.3337" stroke="#141A4D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.16634 2.75L7.33301 19.25" stroke="#141A4D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.6663 2.75L12.833 19.25" stroke="#141A4D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
  }
  
  export default HashtagsDark
  